export default __webpack_public_path__ + "static/media/tented.60c2d895.png";